import React from 'react';
import MIcon from './MIcon';

export default function PortalNotice() {
  return (
    <div style={{
      background: '#FFFBEB', borderBottom: '1px solid #FDE68A',
      padding: '8px 24px', textAlign: 'center', fontSize: 12.5, color: '#92400E',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
    }}>
      <MIcon name="construction" size={15} />
      Estamos mejorando este portal — puede que veas algún fallo visual estos días.
    </div>
  );
}
